import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { marketingMessageStatusSchema } from "./enums.js";
/**
 * Pazarlama iletisi (ADR 0017 §8): YALNIZCA `POST /marketing/messages` üzerinden gider. Her alıcı için izin gönderim
 * ANINDA defterden değerlendirilir; izin yoksa `SKIPPED_NO_PERMISSION`, iletişim bilgisi yoksa `SKIPPED_NO_CONTACT`,
 * anonimleştirilmişse `SKIPPED_ANONYMIZED` olarak günlüğe yazılır. İşlemsel ileti (OTP, fiş) bu yoldan GİTMEZ.
 */
export const MARKETING_CHANNELS = ["SMS", "EMAIL"];
export const marketingChannelSchema = z.enum(MARKETING_CHANNELS);
export const sendMarketingMessageSchema = z
    .object({
    channel: marketingChannelSchema,
    subject: z.string().trim().min(1).max(200).nullable().default(null).describe("E-postada zorunlu"),
    body: z.string().trim().min(1).max(1000),
    customerProfileIds: z.array(uuidSchema).min(1).max(1000).optional(),
    segment: z
        .object({
        homeStationId: uuidSchema.nullable().default(null).describe("Boşsa tüm etkin müşteriler"),
    })
        .optional()
        .describe("Etkin müşterilerden seçim (en çok 1.000 alıcı)"),
})
    .refine((value) => (value.customerProfileIds === undefined) !== (value.segment === undefined), {
    path: ["customerProfileIds"],
    message: "Alıcılar ya müşteri listesiyle ya da segmentle verilmelidir (ikisi birden değil)",
})
    .refine((value) => value.channel !== "EMAIL" || value.subject !== null, {
    path: ["subject"],
    message: "E-posta iletisinde konu zorunludur",
});
export const marketingBatchResultSchema = z.object({
    batchId: uuidSchema,
    channel: marketingChannelSchema,
    total: z.number().int(),
    sent: z.number().int(),
    skippedNoPermission: z.number().int(),
    skippedNoContact: z.number().int(),
    skippedAnonymized: z.number().int(),
    failed: z.number().int(),
});
export const marketingMessageSchema = z.object({
    id: uuidSchema,
    batchId: uuidSchema,
    customerProfileId: uuidSchema,
    customerCode: z.string().nullable(),
    channel: marketingChannelSchema,
    subject: z.string().nullable(),
    bodyPreview: z.string(),
    status: marketingMessageStatusSchema,
    reason: z
        .string()
        .nullable()
        .describe("Gönderilmeme / hata gerekçesi (Türkçe); atlanan (SKIPPED_*) ve hatalı satırda her zaman dolu"),
    providerRef: z.string().nullable(),
    createdBy: uuidSchema.nullable(),
    createdAt: timestampSchema,
});
export const marketingMessagePageSchema = pageOf(marketingMessageSchema);
export const listMarketingMessagesQuerySchema = pageQuerySchema.extend({
    batchId: uuidSchema.optional(),
    customerProfileId: uuidSchema.optional(),
    status: marketingMessageStatusSchema.optional(),
});
//# sourceMappingURL=marketing.js.map